module.exports = __webpack_public_path__ + "static/img/iconFive.2e0e750f.svg";